export default __webpack_public_path__ + "static/media/change_icon1.26f26b73.svg";